import { render, staticRenderFns } from "./Contactos.vue?vue&type=template&id=476b0846&scoped=true"
import script from "./Contactos.vue?vue&type=script&lang=js"
export * from "./Contactos.vue?vue&type=script&lang=js"
import style0 from "./Contactos.vue?vue&type=style&index=0&id=476b0846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476b0846",
  null
  
)

export default component.exports